import React, { useState, useEffect } from "react";
import { Container, Table, Button, Spinner, Alert } from "react-bootstrap";
import { get } from "../../services/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import { FaPlus, FaMinus } from "react-icons/fa";
import CoursesFormAdm from "./CoursesFormAdm";
import CoursesEditAdm from "./CoursesEditAdm";
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";
import "../EventOrganization/Fonts/Playball-Regular-bolditalic.js";
import "../EventOrganization/Fonts/Pattaya-Regular-bolditalic.js";
import jsPDF from "jspdf";
import ParticipantsModal from "./ParticipantsModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { diploma_Seminarios_Base64 } from "../EventOrganization/Certificates/diploma_seminarios_base64.js";

const FloatingButton = ({ onClick, icon, title, position }) => (
  <button
    className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
    onClick={onClick}
    aria-label={title}
    title={title}
    style={{
      background: "linear-gradient(135deg, #007bff, #6610f2)",
      color: "white",
      fontSize: "1.5rem",
      border: "none",
      width: "60px",
      height: "60px",
      transition: "transform 0.2s ease, box-shadow 0.3s ease",
      zIndex: 1050,
      bottom: "20px",
      right: position === "add" ? "20px" : "90px",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    {icon}
  </button>
);

const CoursesAdm = () => {
  const location = useLocation();
  const { ConfigId, eventName, eventId } = location.state || {};
  const [courseToEdit, setCourseToEdit] = useState(null);
  const [coursesData, setCoursesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [schools, setSchools] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [schoolMembers, setSchoolMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [courseParticipants, setCourseParticipants] = useState([]);
  const navigate = useNavigate();
  const fetchCourses = async () => {
    setLoading(true);
    setError(null);

    try {

      const response = await get(
        `https://ectech-software.com.ar/api/academy/events/${ConfigId}/courses?page=0&size=10`
      );
      console.log("📩 Respuesta de la API:", response);

      if (response.data?.content?.length > 0) {
        setCoursesData(response.data.content);
      } else {
        setCoursesData([]);
        setError("No se encontraron cursos.");
      }
    } catch (err) {
      console.error("❌ Error al obtener los cursos:", err);
      setError("Error al cargar los cursos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!ConfigId) {
      console.error("Error: eventId no está definido");
      setError("Error: No se encontró el ID del evento.");
      setLoading(false);
      return;
    }

    fetchCourses();
  }, [ConfigId]);

  const refetchCourses = () => {
    fetchCourses();
  };




  const handlePrintParticipants = async (courseId) => {
    try {
      const [participantsResponse, eventResponse, coursesResponse] = await Promise.all([
        get(`https://ectech-software.com.ar/api/academy/events/${ConfigId}/courses/${courseId}/participants`),
        get(`https://ectech-software.com.ar/api/academy/events/${eventId}`),
        get(`https://ectech-software.com.ar/api/academy/events/${ConfigId}/courses?page=0&size=10`)
      ]);

      const participantsData = participantsResponse.data || [];
      const eventData = eventResponse.data;
      const coursesData = coursesResponse.data.content || [];

      const currentCourse = coursesData.find(course => course.id === courseId) || {};

      const formatDateLongSpanish = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        const localDate = new Date(`${year}-${month}-${day}T00:00:00`);

        return localDate.toLocaleDateString("es-ES", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      };



      const doc = new jsPDF("landscape");
      let pageCount = 0;

      const eventCompetitionNumber = eventData.config?.competitionNumber || "Certamen";
      const eventName = eventData.name || "";
      const eventCity = eventData.config?.city?.name || "";
      const formattedCourseDate = formatDateLongSpanish(currentCourse.courseDate);

      const courseName = currentCourse.name || "";
      const level = currentCourse.level?.name || "";
      const dancePerformance = currentCourse.teacher || "";

      participantsData.forEach((escuela, idx) => {
        const participants = escuela.participants || [];

        participants.forEach((member) => {
          if (typeof member !== "string") return;
          if (pageCount > 0) doc.addPage();
          doc.addImage(diploma_Seminarios_Base64, 'PNG', 0, 0, 297, 210);
          doc.setFont("cambria", "normal");
          doc.setFontSize(24);
          doc.text("Certificamos que", 148, 45, { align: "center" });

          doc.setFont("Playball-Regular", "bolditalic");
          doc.setFontSize(50);
          doc.setTextColor('AB8E5B');
          doc.text(member.trim(), 148, 65, { align: "center" });

          doc.setFont("cambria", "normal");
          doc.setFontSize(23);
          doc.setTextColor('#000000');
          doc.text(`Participó del ${eventCompetitionNumber} Certamen`, 148, 80, { align: "center" });

          doc.setFont("Playball-Regular", "bolditalic");
          doc.setFontSize(50);
          doc.text(`${eventName}`, 148, 100, { align: "center" });

          doc.setFont("cambria", "normal");
          doc.setFontSize(23);
          doc.text(`En el Seminario ${courseName} - Nivel ${level}`, 148, 115, { align: "center" });

          doc.text(`Dictado por ${dancePerformance}`, 148, 126, { align: "center" });

          doc.setFont("cambria", "italic");
          doc.setFontSize(14);
          doc.text(`${eventCity} - ${formattedCourseDate}`, 148, 200, { align: "center" });

          pageCount++;
        });
      });

      doc.save(`certificados_seminarios ${level}.pdf`);

    } catch (error) {
      console.error("Error al generar los certificados:", error);
      toast.error("Hubo un error al generar los certificados.");
    }
  };



  return (
    <Container className="mt-4">
      <h2 className="text-center fw-bold text-primary">Seminarios y Congresos</h2>

      {loading && (
        <Spinner animation="border" role="status" className="d-block mx-auto">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      )}

      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      {!loading && !error && coursesData.length > 0 && (
        <Table striped bordered hover className="text-center">
          <thead className="table-primary">
            <tr>
              <th>Seminario/Congreso</th>
              <th>Nombre</th>
              <th>Profesor/a</th>
              <th>Nivel</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {coursesData.map((curso) => (
              <tr key={curso.id}>
                <td>{curso.type?.name || "N/A"}</td>
                <td>{curso.name || "Sin nombre"}</td>
                <td>{curso.teacher || "Desconocido"}</td>
                <td>{curso.level?.name || "No especificado"}</td>
                <td>
                  {(() => {
                    const [year, month, day] = curso.courseDate.split("-");
                    return `${day}/${month}/${year}`;
                  })()}
                </td>
                <td>
                  <Button variant="warning" size="sm" className="me-2" onClick={() => {
                    setCourseToEdit(curso);
                    setShowForm(true);
                  }}>
                    Editar
                  </Button>
                  <Button variant="success" size="sm" className="me-2" onClick={() => {
                      navigate("/courses/coursesparticipants", {
                        state: {
                          configId: ConfigId,
                          courseId: curso.id,
                          courseName: curso.name,
                          courseLevel: curso.level?.name,
                          event_Name: eventName,
                        },
                      });
                    }}
                  > <FontAwesomeIcon icon={faUsers} />
                    inscriptos
                  </Button>
                  
                  <Button
                    variant="primary" size="sm" className="me-2"
                    onClick={() => handlePrintParticipants(curso.id)}
                  > <FontAwesomeIcon icon={faPrint} /> Certificados
                  </Button>
                  
                  <Button variant="secondary" size="sm" className="me-2"
                                     onClick={() => setShowParticipantsModal(true)}
                  >
                    Participantes
                  </Button>
                </td>

              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {!loading && !error && coursesData.length === 0 && (
        <Alert variant="info" className="text-center">
          No hay cursos disponibles.
        </Alert>
      )}

      {showForm && (
        courseToEdit ? (
          <CoursesEditAdm
            courseToEdit={courseToEdit}
            ConfigId={ConfigId}
            setShowForm={(v) => {
              setShowForm(v);
              if (!v) setCourseToEdit(null); // resetear cuando se cierra
            }}
            refetch={refetchCourses}
          />
        ) : (
          <CoursesFormAdm
            ConfigId={ConfigId}
            setShowForm={setShowForm}
            refetch={refetchCourses}
          />
        )
      )}

      {/* Botón flotante para agregar */}
      <FloatingButton
        onClick={() => {
          setCourseToEdit(null);
          setShowForm(true);
        }}
        icon={<FaPlus />}
        title="Agregar nuevo curso"
        position="add"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <ParticipantsModal
        show={showParticipantsModal}
        onHide={() => setShowParticipantsModal(false)}
        configId={ConfigId}
        eventName={eventName}
      />



    </Container>

  );
};

export default CoursesAdm;
